import { from } from "rxjs";
import { mergeMap } from "rxjs/operators";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import CartRemovalListenerInterface from "./CartRemovalListenerInterface";
import CartRemovalListenerStrategyInterface from "./CartRemovalListenerStrategyInterface";

class CartRemovalListener implements CartRemovalListenerInterface {
    strategies: CartRemovalListenerStrategyInterface[] = [];
    constructor(private readonly logger: LoggerInterface) {}
    listen() {
        this.logger.debug("CartRemovalListener.listen start cart listening");

        return from(this.strategies).pipe(
            mergeMap((strategy) => {
                const listenResult = strategy.listen();

                return listenResult;
            })
        );
    }
    register(strategy: CartRemovalListenerStrategyInterface) {
        this.logger.debug("CartRemovalListener.register new strategy", {
            strategy,
        });
        this.strategies.push(strategy);
    }
}

export default CartRemovalListener;
